import RatingForm from './template';
import { hot } from 'react-hot-loader/root';
export default hot(RatingForm);
